import React, {useEffect, useState} from "react";
import SideBar from "../../../common/SideBar";
import NavBar from "../../../common/NavBar";
import {Link} from "react-router-dom";
import AgentService from "../../../services/AgentService";
import Select from "@material-ui/core/Select";
import ManagerService from "../../../services/ManagerService";
import {toast, ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Spinner from "reactjs-simple-spinner";
import EmployerService from "../../../services/EmployerService";


const EditAgent = (props) => {

    const [name, setName] = useState('');
    const [surname, setSurname] = useState('');
    const [email, setEmail] = useState('');
    const [contactNumber, setContactNumber] = useState('');
    const [position, setPosition] = useState('');
    const [positionId, setPositionId] = useState('');
    const [team, setTeam] = useState('');
    const [teamId, setTeamId] = useState('');
    const [channel, setChannel] = useState('');
    const [channelId, setChannelId] = useState('');
    const [managerId, setManagerId] = useState('');
    const [manager, setManager] = useState('');
    const [agentType, setAgentType] = useState('');
    const [aggregatorId, setAggregatorId] = useState('');
    const [aggregator, setAggregator] = useState('');
    const [agentCode, setAgentCode] = useState('');
    const [managers, setManagers] = useState([]);
    const [channels, setChannels] = useState([]);
    const [positions, setPositions] = useState([]);
    const [teams, setTeams] = useState([]);
    const [aggregators, setAggregators] = useState([]);
    const [loading, setLoading] = useState(false);


    const handleChangeName = (e) => {
        console.log(e.target.value)
        setName(e.target.value);
    }
    const handleChangeSurname = (e) => {
        console.log(e.target.value)
        setSurname(e.target.value);
    }
    const handleChangeEmail = (e) => {
        console.log(e.target.value)
        setEmail(e.target.value)
    }
    const handleChangeContactNumber = (e) => {
        console.log(e.target.value)
        setContactNumber(e.target.value);
    }
    const handleChangeAgentCode = (e) => {
        console.log(e.target.value)
        setAgentCode(e.target.value);
    }
    const handleChangeTeam = (e) => {
        setTeam(e.target.value);
    }
    const handleChangeChannel = (e) => {
        setChannel(e.target.value);
    }

    const handleChangeAgentType = (e) => {
        setAgentType(e.target.value);
    }
    const handleChangeManager = (e) => {
        setManager(e.target.value);
    }

    const handleChangeAggregator = (e) => {
        setAggregator(e.target.value);
    }

    const handleUpdate = (e) => {
        e.preventDefault();
        setLoading(true);
        //call update endpoint
        let data = {
            'agentId': JSON.parse(localStorage.getItem('agentId')),
            'name': name,
            'surname': surname,
            'email': email,
            'contact_number': contactNumber,
            'channel': channel,
            'team': team,
            'position': position,
            'manager': manager,
            'agent_code': agentCode,
            'agent_type': agentType,
            'aggregator_name': aggregator

        }

        console.log(data);
        AgentService.updateAgent(data)
            .then(res => {
                console.log(res);
                if(res.status === 200){
                    toast('Agent Updated Successfully', {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                    setLoading(false);
                }else{
                    setLoading(false);
                     toast.warning('Operation Failed', {
                         position: "top-center",
                         autoClose: 3000,
                         hideProgressBar: false,
                         closeOnClick: true,
                         pauseOnHover: true,
                         draggable: true,
                         progress: undefined,
                     });
                }
            })
            .catch(err => {
                setLoading(false);
                toast.warning('Operation Failed, error:' + err, {
                    position: "top-center",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
                console.log(err);
            })
    }

    useEffect(() => {
        setLoading(true);
        const id  =  JSON.parse(localStorage.getItem('agentId'));
        AgentService.getAgentDetails(id).then(response => {
            console.log(response);
            setSurname(response.data.agent.surname);
            setName(response.data.agent.name)
            setEmail(response.data.agent.email)
            setContactNumber(response.data.agent.contact_number)
            setTeamId(response.data.agent.team_id)
            setTeam(response.data.agent.team)
            setChannelId(response.data.agent.channel_id)
            setChannel(response.data.agent.channel)
            setManagerId(response.data.agent.manager_id)
            setManager(response.data.agent.manager)
            setPositionId(response.data.agent.position_id)
            setPosition(response.data.agent.position)
            setAggregatorId(response.data.agent.aggregator_id)
            setAggregator(response.data.agent.aggregator_name)
            setAgentType(response.data.agent.agent_type)
            setAgentCode(response.data.agent.agent_code)

            setLoading(false);
        }).catch(err => {
            console.log(err);
            setLoading(false);
            toast.warning('Operation Failed, Reload Page\nIf error persists contact System Administrator ')
        });


        ManagerService.getAllManagers().then(res => {
            console.log(res.data);
            setManagers(res.data.managers);
            setLoading(false);
        }).catch(err => {
            console.log(err);
            setLoading(false);
            toast.warning('Operation Failed, Reload Page\nIf error persists contact System Administrator ')
        });
        AgentService.getAllTeams().then(response => {
            console.log(response);
            if (response === undefined) {
                setTeams([])
            }
            let teams = response.teams;
            setTeams(teams);

            //   console.log();                                                                                        );
        }).catch(err => {
            console.log(err);
            setTeams([])
        });
        AgentService.getAllChannels().then(response => {
            console.log(response);
            if (response === undefined) {
                setChannels([])
            }
            let channels = response.channels;
            setChannels(channels);

        }).catch(err => {
            console.log(err);
            setChannels([])
        });
        AgentService.getAllPositions().then(response => {
            console.log(response);
            if (response === undefined) {
                setPositions([])
            }
            let positions = response.positions;
            setPositions(positions);

            //   console.log();                                                                                        );
        }).catch(err => {
            console.log(err);
            setPositions([])
        });
        let token = JSON.parse(localStorage.getItem('token'));

        console.log("token", token)
        EmployerService.getAllEmployers().then(response => {
            console.log('aggr', response);
            if (response !== null || response !== undefined) {
                setAggregators(response);
            } else if (response.status === 401) {
                setAggregators([])
            } else {
                setAggregators([])
            }
        }).catch(err => {
            setAggregators([])
            console.log(err);
            toast.warning('Failed to get all aggregators')
        });

    }, []);

    return(
        <div>
            <ToastContainer
                position="top-center"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
            <SideBar roles={JSON.parse(localStorage.getItem('roles'))}/>
            <div id="main-content" className="main-panel ps-container ps-theme-default">
              <NavBar roles={JSON.parse(localStorage.getItem('roles'))}/>
                <div className="content">
                    <div className="container-fluid">
                        <ul className="breadcrumb">
                            <Link to="/dashboard">
                                <a href=""> <i className="fa fa-home"/>&nbsp;Dashboard </a>
                            </Link>   &nbsp;|&nbsp;
                            <Link to="/agents">
                                <a href=""> Sales Army </a>
                            </Link>
                             &nbsp;|&nbsp;
                            {name}&nbsp;{surname}
                        </ul>
                        <div className="row mt">


                            <div className="col-lg-12">
                                <div className="card">
                                    {loading && (
                                        <div className="mr-5 ml-5 mt-5 mb-5 p-5">
                                            <Spinner
                                                size="large"
                                                message="Please wait....."
                                                line-fg-color="#64c3c2"
                                            />
                                        </div>

                                    )}
                                    {!loading && (
                                        <form id="employerData" onSubmit={handleUpdate}>
                                            <div id="form-style">
                                                <div className="form-row">
                                                    <div className="form-group col-md-6">
                                                        <label>Name</label>

                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            value={name}
                                                            name="name"
                                                            onChange={handleChangeName}
                                                        />
                                                    </div>
                                                    <div className="form-group col-md-6">
                                                        <label>Surname</label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            value={surname}
                                                            name="surname"
                                                            onChange={handleChangeSurname}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="form-row">
                                                    <div className="form-group col-md-6">
                                                        <label>Email</label>
                                                        <input
                                                            type="email"
                                                            className="form-control"
                                                            value={email}
                                                            name="email"
                                                            onChange={handleChangeEmail}
                                                        />
                                                    </div>

                                                    <div className="form-group col-md-6">
                                                        <label>Contact Number</label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            value={contactNumber}
                                                            name="contactNumber"
                                                            onChange={handleChangeContactNumber}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="form-row">
                                                    <div className="form-group col-md-6">
                                                        <label>Agent Code</label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            value={agentCode}
                                                            name="agentCode"
                                                            onChange={handleChangeAgentCode}
                                                        />
                                                    </div>
                                                </div>
                                                <hr/>
                                                <div className="form-row">
                                                    <div className="form-group col-md-6">
                                                        <label>Team: <b>{team}</b></label>
                                                        <Select margin="dense" className="form-control"
                                                                onChange={handleChangeTeam} name="team">
                                                            <option disabled={true} value>Select Team</option>
                                                            {teams.map((tea, i) => {
                                                                return (
                                                                    <option key={i}
                                                                            value={tea.teamTitle}>{tea.teamTitle}</option>

                                                                )
                                                            })}
                                                        </Select>
                                                    </div>
                                                    <div className="form-group col-md-6">
                                                        <label>Agent Type: <b>{agentType}</b></label>
                                                        <Select className="form-control"
                                                                onChange={handleChangeAgentType} name="agent_type">
                                                            <option disabled={true} value>Select Agent Type</option>
                                                            <option value='TIED'>Tied</option>
                                                            <option value='EXECUTIVE'>Executive</option>
                                                            <option value='CDA'>Client Delight Assistant</option>
                                                        </Select>
                                                    </div>
                                                </div>
                                                <div className="form-row">

                                                    <div className="form-group col-md-6">
                                                        <label>Channel: <b>{channel}</b></label>
                                                        <Select className="form-control" onChange={handleChangeChannel}
                                                                name="channel">
                                                            <option disabled={true} value>Select Channel</option>
                                                            {channels.map((cha, i) => {
                                                                return (
                                                                    <option key={i} value={cha.channelTitle}
                                                                    >{cha.channelTitle}</option>

                                                                )
                                                            })}
                                                        </Select>
                                                    </div>
                                                    <div className="form-group col-md-6">
                                                        <label>Manager: <b>{manager}</b></label>
                                                        <Select className="form-control" onChange={handleChangeManager}
                                                                name="managerId">
                                                            <option value disabled>Select Manager</option>
                                                            {managers.map((a, i) => {
                                                                return (
                                                                    <option key={i}
                                                                            value={a.name + ' ' + a.surname}>{a.name}{a.surname}</option>
                                                                )
                                                            })}

                                                        </Select>
                                                    </div>
                                                    <div className="form-group col-md-6">
                                                        <label>Aggregator: <b>{aggregator}</b></label>
                                                        <Select className="form-control"
                                                                onChange={handleChangeAggregator} name="aggregator">
                                                            <option disabled={true} value>Select Aggregator</option>
                                                            {aggregators.map((agg, i) => {
                                                                return (
                                                                    <option key={i} value={agg.name}>{agg.name}</option>
                                                                )
                                                            })}
                                                        </Select>
                                                    </div>
                                                </div>
                                                <div className="form-row">
                                                    <div className="form-group col-md-12">
                                                        <Link to="/agents">
                                                            <button className="btn btn-info btn-sm">
                                                                <i className="fa fa-backward"/>&nbsp;&nbsp;Back
                                                            </button>
                                                        </Link>
                                                        <button
                                                            onClick={handleUpdate}
                                                            id="addEmployer"
                                                            className="btn btn-success btn-sm  ld-ext-right"
                                                        >
                                                            Update &nbsp;&nbsp;<i className="fa fa-send"/>&nbsp;&nbsp;

                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </form>
                                    )}
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default EditAgent;
